import { MessageOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { ButtonProps } from 'antd/es/button';
import { useTransAppProductName } from 'hooks/useTrans';
import { ContactBuyer, ContactBuyerProps } from './ContactBuyer';

export interface ContactBuyerBtnProps extends Omit<ContactBuyerProps, 'children'> {
  ghost?: boolean;
  size?: ButtonProps['size'];
  disabled?: boolean;
}

const ContactBuyerBtn = (props: ContactBuyerBtnProps) => {
  const { ghost = true, size = 'middle', disabled = false, ...rest } = props;
  const appProductNameT = useTransAppProductName();

  return (
    <ContactBuyer {...rest}>
      {({ onClick }) => (
        <Button
          type="primary"
          ghost={ghost}
          size={size}
          icon={<MessageOutlined />}
          onClick={onClick}
          disabled={disabled}
        >
          {appProductNameT('tableColumn.contactBuyerNow')}
        </Button>
      )}
    </ContactBuyer>
  );
};

export default ContactBuyerBtn;
